import InspectionCenter from './inspection_center.vue';

export default InspectionCenter;
